// Every dialog the money screen opens, in one place. Moved out of CollectionsBoard at the
// file-length ceiling when correcting and cancelling a charge joined recording, paying
// and skipping. At most one is open at a time; each closes through `onClose` and, once
// something was written, through `onSaved` — which reloads the screen and the sidebar dot.
import PaymentModal from '../../components/PaymentModal';
import RecordChargeModal from '../../components/RecordChargeModal';
import SkipMonthModal from './SkipMonthModal';
import CorrectChargeModal from '../../components/CorrectChargeModal';
import CancelChargeModal from '../../components/CancelChargeModal';
import ChargePaymentsModal from './ChargePaymentsModal';

export default function BoardDialogs({
  recording, paying, skipping, correcting, cancelling, paymentsOf, onClose, onSaved,
}) {
  return (
    <>
      {/* Recording a charge: the invoice and its photo in one action, with the
          conversion stated first when there is one. */}
      {recording && (
        <RecordChargeModal
          card={recording.card}
          month={recording.month || null}
          expense={recording.expense || null}
          onClose={onClose}
          onSaved={onSaved}
        />
      )}
      {/* Collecting against a charge. The SAME component the old screens used — a
          payment is a payment, and a second definition of one is how two screens drift. */}
      {paying && (
        <PaymentModal
          // The issuer seeds "who collected"; what is already paid decides whether it
          // may still change (only until the first payment).
          invoice={{
            id: paying.invoiceId,
            balance: paying.balance,
            paid: paying.paid,
            issuingPartnerId: paying.issuingPartnerId,
          }}
          onClose={onClose}
          onSaved={onSaved}
        />
      )}
      {skipping && (
        <SkipMonthModal
          card={skipping.card}
          month={skipping.month}
          onClose={onClose}
          onSaved={onSaved}
        />
      )}
      {/* A recorded charge whose amount, date or issuer was recorded wrong. */}
      {correcting && (
        <CorrectChargeModal
          card={correcting.card}
          row={correcting.row}
          onClose={onClose}
          onSaved={onSaved}
        />
      )}
      {/* The installments behind a charge, each of which can be undone. */}
      {paymentsOf && (
        <ChargePaymentsModal
          card={paymentsOf.card}
          row={paymentsOf.row}
          onClose={onClose}
          onSaved={onSaved}
        />
      )}
      {/* A charge recorded by mistake, with nothing collected against it. */}
      {cancelling && (
        <CancelChargeModal
          card={cancelling.card}
          row={cancelling.row}
          onClose={onClose}
          onSaved={onSaved}
        />
      )}
    </>
  );
}
